<template>
  <div id="container" class="flex_one">
    <div class="list_box full_layout" :class="{'warehouse1400':isWhat[1]=='warehouse'}">
      <div class="list_left_box">
        <ul class="my_card_hoddy">
          <li :class="(isWhat[1]=='recently')?'on':''">
            <router-link :to="{path:'/mycardhobby/recently'}">{{$t('base.recentlyViewed')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='bids')?'on':''">
            <router-link :to="{path:'/mycardhobby/bids'}">{{$t('base.bidsOffers')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='purchase')?'on':''" class="overseasWarehouse purchase">
            <router-link :to="{path:'/mycardhobby/purchase'}">{{$t('base.purchaseHistory')}}</router-link>
            <router-link :to="{path:'/terms/purchase'}" target="_blank" class="icon_process"></router-link>
          </li>
          <li :class="(isWhat[1]=='mallorder')?'on':''">
            <router-link :to="{path:'/mycardhobby/mallorder'}">{{$t('base.mallOrders')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='watch')?'on':''">
            <router-link :to="{path:'/mycardhobby/watch'}">{{$t('base.watchList')}}</router-link>
          </li>
          <li :class="(['vault'].includes(isWhat[0]))?'on':''" class="overseasWarehouse">
            <router-link :to="{path:'/vault/buyerpanel'}">{{$t('vault.CardHobbyVault')}}</router-link>
            <router-link :to="{path:'/terms/vault'}" target="_blank" class="icon_process"></router-link>
            <!-- <a :href="vaultUrl" target="_blank" class="icon_process"></a> -->
          </li>
          <li :class="(isWhat[1]=='warehouse')?'on':''" class="overseasWarehouse">
            <router-link :to="{path:'/mycardhobby/warehouse'}">{{$t('base.overseaWarehouse')}}</router-link>
            <router-link :to="{path:'/terms/process'}" target="_blank" class="icon_process"></router-link>
          </li>
          <li :class="(isWhat[1]=='search')?'on':''" class="overseasWarehouse">
            <router-link :to="{path:'/mycardhobby/search'}" @click="saveDate()">{{$t('title.savedSearches')}}</router-link>
            <div class="tabLiPopover" v-if="isSaveTime">
              <span class="textTitle">{{$t('base.New')}}</span>
              <span class="textBox">{{$t('alert.Youcanseeyoursaved')}}</span>
            </div>
          </li>
          <li :class="(isWhat[1]=='sellers')?'on':''">
            <router-link :to="{path:'/mycardhobby/sellers'}">{{$t('base.savedSellers')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='coupons')?'on':''">
            <router-link :to="{path:'/mycardhobby/coupons'}">{{$t('base.myCoupons')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='setting')?'on':''">
            <router-link :to="{path:'/mycardhobby/setting'}">{{$t('base.accountSettings')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='chp')?'on':''">
            <router-link :to="{path:'/mycardhobby/chp'}">{{$t('base.myCHP')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='taxrefund')?'on':''"  v-if="userInfo!=null&&userInfo.MemberSource=='US'">
            <router-link :to="{path:'/mycardhobby/taxrefund'}">{{$t('title.taxrefund')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='activity')?'on':''">
            <router-link :to="{path:'/mycardhobby/activity'}">{{$t('base.Promotions')}}</router-link>
          </li>
          <li :class="(isWhat[1]=='bolck')?'on':''">
            <router-link :to="{path:'/mycardhobby/block'}">{{$t('base.blocked')}}</router-link>
          </li>
          <!-- Tax refund -->
        </ul>
      </div>
      <div class="list_right_box" v-if="(userInfo!=null)||(isWhat[1]=='activity')">
        <router-view :userInfo='userInfo'></router-view>
      </div>
      <div class="list_right_box" v-else>
        <div class="user_no">{{$t('base.please')}} <router-link :to="{path:'/login'}" class="text_blue">{{$t('base.loginLower')}}</router-link> {{$t('alert.toViewItems')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import { getInfo,setUTC } from "@/api/public";

export default {
  name: 'tabslist',
  data() {
    return {
      userInfo: null,
      isWhat: this.$route.path.slice(1).split("/"),
      isSaveTime:this.$store.state.isSaveTime
    }
  },
  watch: {
    '$route': 'getPath'
  },
  mounted() {},
  computed: {
    vaultUrl() {
      return `${process.env.VUE_APP_CARD_URL}/vault/ratingWeb.html`
    }
  },
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('base.myCardHobby'));
    this.userInfo = getInfo()
    if (this.userInfo == null) {
      // Please sign in to view items.
    }
  },
  methods: {
    saveDate(){
      if(this.userInfo){
        var time=new Date().getTime();

        //console.log(setUTC(time, -8, 'cn').getTime(),time)
        
      }
    },
      //window.localStorage.getItem('saveDate')?window.localStorage.getItem('saveDate'):''
    getPath() {
      let that = this
      this.isWhat = this.$route.path.slice(1).split("/")
      this.$store.commit('SET_HEADER_TITLE', that.$t('base.myCardHobby'));
    },

  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";

.tabLiPopover {
  position: absolute;
  right: 16px;
  top: 20px;
}

.tabLiPopover .textTitle {
  color: #E02020;
  cursor: pointer;
}

.tabLiPopover .textBox {
  display: none;
  position: absolute;
  height: 60px;
  width: 200px;
  background-color: #5F6DAE;
  color: #fff;
  box-sizing: border-box;
  padding: 8px 20px;
  line-height: 1.5;
  top: -19px;
  left: 40px;
  border-radius: 4px;
  z-index: 9;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.10);
}

.tabLiPopover .textBox:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #5F6DAE;
  display: inline-block;
  position: absolute;
  top: 20px;
  left: -5px;
  transform: rotate(45deg);
}
.tabLiPopover:hover .textBox{
  display: block;
}
/* .warehouse1400{
  width: 1400px;
}
.warehouse1400 .list_right_box{
  width: 1200px;
} */
.warehouse1400 .thousand_layout{
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/tabslist.vue